export enum ActionStageEnum {
  Undefined = 0,
  Open,
  Waiting,
  Aborted,
  Completed,
  Warning
}
